module.exports = __webpack_public_path__ + "203aa84f70a1b725557ef3f5d3e3dc29.png";